// S3 のマルチパートアップロードのパート数の上限。
// サーバーの MultipartUploadService::MAX_TOTAL_PARTS と同じ値にすること。
const MAX_TOTAL_PARTS = 10000;

/**
 * ファイルサイズに応じて partSize / queueSize を決める。
 * partSize は基準以上で、パート数が上限を超えない大きさにする
 * (lib-storage の既定は floor で割るため、ceil で明示する)。
 * queueSize は partSize が大きくなった分だけ減らし、ブラウザが同時に持つ量を基準以内に抑える。
 *
 * @param {number} fileSize ファイルのバイト数
 * @param {number} basePartSize 基準の partSize (バイト)
 * @param {number} baseQueueSize 基準の queueSize
 * @returns {{ partSize: number, queueSize: number }}
 */
export function resolveUploadPartPlan(fileSize, basePartSize, baseQueueSize) {
  const partSize = Math.max(basePartSize, Math.ceil(fileSize / MAX_TOTAL_PARTS));
  const queueSize = Math.max(
    1,
    Math.min(baseQueueSize, Math.floor((basePartSize * baseQueueSize) / partSize)),
  );
  return { partSize, queueSize };
}
